import React, { useState } from "react";
import api from "api";
import styles from "../stripe-dashboard.module.css";
import AppModal from "components/ui/AppModal/AppModal";

const EMPTY = {
  name:         "",
  price:        "",
  interval:     "month",
  storage:      "",
  max_projects: "",
  max_reports:  "",
  is_custom:    "true",
};

const CreatePlanTab = ({ token, onPlanCreated }) => {
  const [loading, setLoading] = useState(false);
  const [plan, setPlan]       = useState(EMPTY);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "OK"
  });

  const closeFeedbackModal = () =>
    setFeedbackModal(prev => ({ ...prev, open: false }));

  const handle = e => {
    const { name, value } = e.target;
    setPlan(p => ({ ...p, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/v2/stripe/plans", plan, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFeedbackModal({
        open: true,
        variant: "success",
        title: "Sucesso!",
        message: "Novo plano criado."
      });
      setPlan(EMPTY);
      onPlanCreated();
    } catch (err) {
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro",
        message: err.response?.data?.detail || "Verifique os campos."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.card}>
        <form onSubmit={handleSubmit} noValidate>
        <div className={styles.formBody}>

          {/* Nome + Preço */}
          <div className={styles.formGrid2}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Nome do Plano</label>
              <input
                type="text"
                name="name"
                className={styles.formControl}
                value={plan.name}
                onChange={handle}
                placeholder="Ex: Plano Enterprise"
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Preço (R$)</label>
              <input
                type="number"
                name="price"
                className={styles.formControl}
                value={plan.price}
                onChange={handle}
                placeholder="199.90"
                required
              />
            </div>
          </div>

          {/* Limits */}
          <div className={styles.formGrid3}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Armazenamento (GB)</label>
              <input
                type="number"
                name="storage"
                className={styles.formControl}
                value={plan.storage}
                onChange={handle}
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Máx. Projetos</label>
              <input
                type="number"
                name="max_projects"
                className={styles.formControl}
                value={plan.max_projects}
                onChange={handle}
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Máx. Relatórios</label>
              <input
                type="number"
                name="max_reports"
                className={styles.formControl}
                value={plan.max_reports}
                onChange={handle}
                required
              />
            </div>
          </div>

          {/* Customizado */}
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Plano Customizado?</label>
            <select
              name="is_custom"
              className={styles.formControl}
              value={plan.is_custom}
              onChange={handle}
            >
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>

        </div>

        <div className={styles.formActions}>
          <button
            type="submit"
            className={`${styles.button} ${styles.buttonPrimary}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className={styles.spinner} style={{ width: 14, height: 14, borderWidth: 2 }} />
                Criando...
              </>
            ) : (
              <>
                <i className="fas fa-layer-group" /> Criar Plano
              </>
            )}
          </button>
        </div>
        </form>
      </div>

      <AppModal
        isOpen={feedbackModal.open}
        onClose={closeFeedbackModal}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={closeFeedbackModal}
        onCancel={closeFeedbackModal}
      />
    </>
  );
};

export { CreatePlanTab };
